<template>
  <div>
    <nav id="nav_id" class="nav">
      <div class="inner">
        <div class="nav_top">
          <div class="inner">
            <h1 class="h1">
              <span>외식 경영 관리사</span>
            </h1>
          </div>
        </div>
        <div class="nav_btm">
          <div class="inner">
            <div class="line dep01">
              <div class="inner">
                <ul>
                  <li>
                    <button :class="{'on' : navType === 0}" @click="fnMove('/manager/info')">
                      <span>외식 경영 관리사 안내</span>
                    </button>
                  </li>
                  <li>
                    <button :class="{'on' : navType === 1}" @click="fnMove('/manager/edu/apply')"
                      ><span>교육 신청</span></button
                    >
                  </li>
                  <li>
                    <button :class="{'on' : navType === 2}"  @click="fnMove('/manager/exam/apply')"
                      ><span>시험 신청</span></button
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="line dep02" v-if="navType === 1">
              <div class="inner">
                <ul>
                  <li>
                    <router-link tag="button" to="/manager/edu/apply"
                      ><span>교육 신청</span></router-link
                    >
                  </li>
                  <li>
                    <router-link tag="button" to="/manager/edu/register"
                      ><span>접수 확인 및 취소</span></router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="line dep02" v-if="navType === 2">
              <div class="inner">
                <ul>
                  <li>
                    <router-link tag="button" to="/manager/exam/apply"
                      ><span>시험 신청</span></router-link
                    >
                  </li>
                  <li>
                    <router-link tag="button" to="/manager/exam/register"
                      ><span>접수 확인 및 취소</span></router-link
                    >
                  </li>
                  <li>
                    <router-link tag="button" to="/manager/exam/admission"
                      ><span>수험표 출력</span></router-link
                    >
                  </li>
                  <li>
                    <router-link tag="button" to="/manager/exam/notice"
                      ><span>공지사항</span></router-link
                    >
                  </li>
                  <li>
                    <router-link tag="button" to="/manager/exam/certificate"
                      ><span>자격증 발급(재발급)</span></router-link
                    >
                  </li>
                  <li>
                    <router-link tag="button" to="/manager/exam/pass"
                      ><span>합격자 조회</span></router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'manager-index',
  computed: {
    navType: function() {
      if (this.$route.path.indexOf('/edu') > -1) {
        // 교육신청
        return 1
      } else if (this.$route.path.indexOf('/exam') > -1) {
        // 시험신청
        return 2
      }
      // 외식경영관리사안내
      return 0
    }
  },
  methods: {
    fnMove: function(path) {
      this.$router.push({
        path: path
      })
    }
  }
}
</script>

<style scoped></style>
